import type { ValidatedProblem } from '../../../interfaces/containers/premises/ValidatedProblem';

export function isTrafficSignalProblem(problem: ValidatedProblem | undefined): problem is ValidatedProblem {
	const trafficSignal = problem?.symptoms?.safety?.trafficSignal;
	return Boolean(trafficSignal?.blinking || trafficSignal?.out);
}
